import { ViewGamePlayer } from './view-game-player'
import { ViewGameStatus } from '../types/view-game.status'
import { GameSettings } from './game.settings'
import { ViewGame } from './view-game'

interface ViewGameProps {
  readonly gameShortId: string
  readonly viewGameStatus: ViewGameStatus
  readonly gameSettings: GameSettings
  readonly players: ViewGamePlayer[]
  readonly createdAt: Date
}

export class ViewGameAsGuest extends ViewGame {
  public constructor(props: ViewGameProps) {
    super(props)
  }

  public override shouldShowSitAtGame(): boolean {
    return false
  }

  public override shouldShowAcceptInvite(): boolean {
    return false
  }
}
